module.exports = __webpack_public_path__ + "static/media/izziel.61086cfe.jpg";